__turbopack_context__.v({
  "asideIllu": "index-module-scss-module__ZnfrcW__asideIllu",
  "illu3DCanvas": "index-module-scss-module__ZnfrcW__illu3DCanvas",
  "illustration3DScene": "index-module-scss-module__ZnfrcW__illustration3DScene",
});
